import {Base} from "@/api/Base"

export class LeaveDelete extends Base {
    path = "leave/delete"
}